<template>
  <v-snackbar multi-line v-model="visible">
    <div v-html="message"></div>
    <v-btn color="orange" @click="onClose"> Fechar </v-btn>
  </v-snackbar>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapMutations } = createNamespacedHelpers("portal");

export default {
  name: "Toast",
  props: {
    message: String,
    showToast: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false
    };
  },
  watch: {
    showToast: {
      handler() {
        this.visible = this.showToast;
      }
    },
    visible: {
      handler() {
        if (!this.visible) {
          this.onClose();
        }
      }
    }
  },
  methods: {
    ...mapMutations(["clearToast"]),
    onClose() {
      this.clearToast();
    }
  }
};
</script>
